
import { Vue, Component, Prop } from 'vue-property-decorator'
import S from '@/store'
import * as T from '@/types'

@Component
export default class UserDropdown extends Vue {

    @Prop({ type: Object, required: true}) me!: T.User
    @Prop({ type: Boolean, default: true }) light!: boolean

    @S.Auth.Action logout: any

    popoverOpen: boolean = false

    onClickSettings () {
        this.$router.push({ name: T.CrmRoute.VIEW_SETTINGS })
    }

    onClickLogOut () {
        this.logout()
    }

    onClickItem () {
        this.popoverOpen = false
    }

}
